<ng-container *ngIf="node.isExpanded && node.children.length > 0">
  <div class="tree-children" [@animateExpand]="node.isExpanded ? 'expanded' : 'collapsed'">
    <ng-container *ngFor="let child of node.children; let i = index; trackBy: trackByNodeId">
      <ng-container *ngIf="!child.isHidden">
        <ng-container
          *ngTemplateOutlet="templates.treeNodeFullTemplate; context: { $implicit: child, index: i, templates: templates }">
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</ng-container>

